export const getDataFromSessionStorage = (key) => {
  if (typeof window !== 'undefined') {
    const data = window.sessionStorage.getItem(key);
    if (data) {
      try {
        return JSON.parse(data);
      } catch {
        return data;
      }
    }
    return undefined;
  }
  return undefined;
};

export const getRvSkusFromSessionStorage = () => {
  const rvData = getDataFromSessionStorage('rvData');
  if (rvData) {
    try {
      return rvData[0].useractivity.rv.map((item) => item.productId);
    } catch {
      return [];
    }
  }
  return [];
};